import { api } from '../axios'
import type { ApiResponse, Patient } from '@/types'
import type {
  GetPatientsParams,
  GetPatientsResponse,
  CreatePatientData,
  UpdatePatientData,
  DischargePatientData,
} from './patient.static'

export const patientService = {
  async getPatients(params?: GetPatientsParams): Promise<GetPatientsResponse> {
    const response = await api.get<ApiResponse<GetPatientsResponse>>('/patients', { params })
    return response.data.data
  },

  async getPatient(id: string): Promise<Patient> {
    const response = await api.get<ApiResponse<Patient>>(`/patients/${id}`)
    return response.data.data
  },

  async createPatient(data: CreatePatientData): Promise<Patient> {
    const response = await api.post<ApiResponse<Patient>>('/patients', data)
    return response.data.data
  },

  async updatePatient(id: string, data: UpdatePatientData): Promise<Patient> {
    const response = await api.patch<ApiResponse<Patient>>(`/patients/${id}`, data)
    return response.data.data
  },

  async dischargePatient(id: string, data: DischargePatientData): Promise<Patient> {
    const response = await api.post<ApiResponse<Patient>>(`/patients/${id}/discharge`, data)
    return response.data.data
  },

  async reactivatePatient(id: string): Promise<Patient> {
    const response = await api.post<ApiResponse<Patient>>(`/patients/${id}/reactivate`)
    return response.data.data
  },

  async deletePatient(id: string): Promise<void> {
    await api.delete(`/patients/${id}`)
  },
}
